<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">APHT</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-file" />
            APHT
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-5" v-if="$helper.isRole($availRoles['Cabang'])">
        <CButton color="primary" class="float-right mt-2" @click="$router.push({ name: 'APHT Add' })">
          Create <FaIcon icon="plus" />
        </CButton>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="px-0 pb-0" v-if="$helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO'])">
        <!-- <CRow>
          <CCol class="col-xs-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <multiselect 
                    :allow-empty="false"
                    v-model="filter.periodBy" 
                    :options="filter.periodOptions"
                    :searchable="false"
                    id="period-table-apht"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  </multiselect>
                  <b-form-select v-model="filter.periodBy" :options="filter.periodOptions"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="filter.periodStart" 
                    :max="filter.maxPeriodStart"
                    id="filter-period-start"
                    placeholder="DD/MM/YYYY"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodStart"
                    @input="filterDateTable"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-input-group-append>
                  <b-input-group-text>
                    ~
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="filter.periodEnd" 
                    :min="filter.minPeriodEnd"
                    :max="filter.maxPeriodEnd"
                    placeholder="DD/MM/YYYY"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodEnd"
                    @input="filterDateTable"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow> -->
        <CRow class="mt-2">
          <CCol class="col-lg-12 col-xl-8 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white mb-2">
                <b-input-group-prepend>
                  <b-form-select class="period-by-select custom-input-prepend" v-model="filter.periodBy" :options="filter.periodOptions" @change="onChangeFilterDate"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-append>
                  <b-form-datepicker
                    reset-button
                    v-model="filter.periodStart" 
                    :max="filter.maxPeriodStart"
                    id="filter-period-start"
                    placeholder="DD/MM/YYYY"
                    class="custom-label-date"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodStart"
                    @input="getAphtTableItems()"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-input-group-append>
                  <b-input-group-text>
                    ~
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append>
                  <b-form-datepicker
                    reset-button
                    v-model="filter.periodEnd" 
                    :min="filter.minPeriodEnd"
                    placeholder="DD/MM/YYYY"
                    class="custom-label-date"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodEnd"
                    @input="getAphtTableItems()"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-2">
          <CCol class="col-xs-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <b-form-select v-model="filter.value" :options="filter.options" @change="changeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-select v-if="filter.value == 'memoStatus'" v-model="filter.filterSearch" :options="filter.filterMemoStatusOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-input
                    v-else-if="filter.value == 'notaryFee' || filter.value == 'objectPrice'"
                    :value="$helper.thousandSeparator(filter.filterSearch)"
                    maxlength="19"
                    @input="filter.filterSearch = $event.toString().replace(/\./g, '')"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                    placeholder="Search"
                    type="text"
                  ></b-form-input>
                  <b-form-input v-else maxlength="50" v-model="filter.filterSearch" autocomplete="off" placeholder="Search"></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" title="Filter Tabel APHT" :disabled="!aphtTable.isLoaded" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="aphtTable.items"
              :fields="aphtTable.fields"
              :busy="!aphtTable.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onTableSortChanged"
            >
              <template #cell(applNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <!-- <template #cell(certificateNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(certificateStatus)="row">
                {{ $helper.showData(row.value, "string") }}
              </template> -->
              <template #cell(contractMemoNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <!-- <template #cell(creator)="row">
                {{ $helper.showData(row.value, "string") }}
              </template> -->
              <template #cell(memoStatus)="row">
                <template v-if="row.value == 'PE'">Draft</template>
                <template v-else-if="row.value == 'OA'">On Approval</template>
                <template v-else-if="row.value == 'AP'">Approved</template>
                <template v-else-if="row.value == 'RJ'">Rejected</template>
                <template v-else-if="row.value == 'RV'">Need Revise</template>
              </template>
              <!-- <template #cell(contractDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template> -->
              <!-- <template #cell(notaryFee)="row">
                {{ row.value == 0 ? '-' : $helper.showData(row.value, "number") }}
              </template>
              <template #cell(objectPrice)="row">
                {{ row.value == 0 ? '-' : $helper.showData(row.value, "number") }}
              </template> -->
              <template #cell(officeName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <!-- <template #cell(newNotes)="row">
                <CBadge v-if="row.value" color="success">NEW</CBadge>
                <span v-else>-</span>
              </template>
              <template #cell(rejectValidation)="row">
                <span v-if="$helper.isEmpty(row.value) || row.value == false">-</span>
                <CBadge v-else color="danger">REJECTED</CBadge>
              </template> -->
              <template #cell(aphtMemoDate)="row">
                {{ $helper.showData(row.value.split("T")[0], "string") }}
              </template>
              <template #cell(action)="row">
                <CButton size="sm" color="primary" title="Detail APHT" class="btn-icon mr-1 custom-button-action" @click="$router.push({ name: 'APHT Detail', params: { contractMemoNo: row.item.contractMemoNo } })">
                  <b-icon icon="eye"></b-icon>
                </CButton>
              </template>
              <template slot="empty">
                <div v-if="!aphtTable.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="aphtTable.totalRows" :page="aphtTable.currentPage" @limit-change="onTableLimitChange" @page-change="onTablePageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CRow>
      <CCol class="col-12">
        <b-btn variant="warning" class="float-right btn-sm custom-button-white" title="Download kontrak yang tertampil di tabel" style="width:12rem" :disabled="isDownloading || aphtTable.items.length <= 0" @click="downloadContracts">
          <b-spinner small v-if="isDownloading" />
          <span v-else>Download Semua Kontrak</span>
        </b-btn>
      </CCol>
    </CRow>
  </CContainer>
</template>


<script>
export default {
  name: 'APHTListCreated',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      isDownloading: false,
      filter: {
        value: "applNo",
        options: [
          { value: "applNo", text: "No. APPL" },
          { value: "contractMemoNo", text: "No. Memo Kontrak" },
          // { value: "certificateNo", text: "No. Sertifikat" },
          // { value: "certificateStatus", text: "Status Sertifikat" },
          { value: "memoStatus", text: "Status Memo" },
          // { value: "notaryFee", text: "Biaya Notaris" },
          // { value: "objectPrice", text: "Harga Objek" },
          { value: "officeName", text: "Nama Office" },
        ],
        filterSearch: '',
        filterType: '',
        filterValue: '',
        filterMemoStatusOptions: [
          { value: "PE", text: "Draft" },
          { value: "OA", text: "On Approval" },
          { value: "AP", text: "Approved" },
          { value: "RJ", text: "Rejected" },
          { value: "RV", text: "Need Revise" },
        ],
        periodOptions: [
          { value:"aphtMemoDate", text: "Tanggal Pembuatan" }
        ],
        periodBy: "aphtMemoDate",
        periodStart: null,
        maxPeriodStart: today,
        periodEnd: null,
        minPeriodEnd: '',
        maxPeriodEnd: today
      },
      aphtTable: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "applNo", label: "No. APPL", sortable: true},
          {key: "contractMemoNo", label: "No. Memo Kontrak", sortable: true},
          {key: "memoStatus", label: "Status Memo", sortable: true},
          // {key: "certificateNo", label: "No. Sertifikat", sortable: true},
          // {key: "certificateStatus", label: "Status Sertifikat", sortable: true},
          // {key: "memoStatus", label: "Status Memo", sortable: true},
          // {key: "notaryFee", label: "Biaya Notaris (Rp)", sortable: true},
          // {key: "objectPrice", label: "Harga Objek (Rp)", sortable: true},
          {key: "officeName", label: "Nama Office", sortable: true},
          {key: "aphtMemoDate", label: "Tanggal Pembuatan", sortable: true},
          { key: "action", label: "Aksi", sortable: false }
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      }
    }
  },
  methods: {

    changeFilterType() {
      if (this.filter.value == "memoStatus") {
        this.filter.filterSearch = "PE"
      } else{
        this.filter.filterSearch = null
      }
    },

    onChangeFilterDate() {
      if (!this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)) {
        this.getAphtTableItems()
      }
    },
    // update datepicker valid dates on change
    onContextPeriodStart() {
      this.filter.minPeriodEnd = this.filter.periodStart
    },
    onContextPeriodEnd() {
      this.filter.maxPeriodStart = this.filter.periodEnd
    },
    // downloadContracts(page = 1) {
    //   if(isNaN(page)) {
    //     this.aphtTable.currentPage = 1
    //   }
    //   else {
    //     this.aphtTable.currentPage = page
    //   }
    //   // URL builder
    //   let getUrl = "/excel/contractAphtByte"
    //   getUrl += "?page=" + (this.aphtTable.currentPage - 1)
    //   getUrl += "&size=" + this.aphtTable.perPage
    //   if(!this.$helper.isEmpty(this.filter.periodBy)){
    //     getUrl += "&periodBy=" + this.filter.periodBy
    //     if(!this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)){
    //       getUrl += "&periodStart=" + this.filter.periodStart
    //       getUrl += "&periodEnd=" + this.filter.periodEnd
    //     }
    //   }
    //   if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
    //     getUrl += "&filterType=" + this.filter.filterType
    //     getUrl += "&filterValue=" + this.filter.filterValue
    //   }
    //   if(this.aphtTable.sortBy != null) {
    //     getUrl += "&sortBy=" + this.aphtTable.sortBy
    //     getUrl += "&asc=" + !this.aphtTable.sortDesc
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.isDownloading = true
    //     this.$axios.get(getUrl, {
    //       // necessary to avoid encoding returned bytes
    //       responseType: 'blob',
    //      timeout: 300000
    //     }).then(response => {
    //       if(response.status == 200){
    //         // create file Blob and download according to extension
    //         let blob=new Blob([response.data], {type: "application/octet-stream"})
    //         let link=document.createElement('a')
    //         link.href=window.URL.createObjectURL(blob)
    //         link.download= "Kontrak_APHT-" + Date.now() + ".xlsx"
    //         link.click();
    //       }
    //       else{
    //         this.$helper.toastError(this, "Download Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Download Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Download Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.isDownloading = false
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    // update table with server-side processing on change
    onTableLimitChange(newPerPage) {
      this.aphtTable.perPage = newPerPage
      // only fetch data when roles apply
      this.getAphtTableItems()
    },
    onTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getAphtTableItems(newPage)
    },
    onTableSortChanged(ctx) {
      this.aphtTable.sortBy = ctx.sortBy
      this.aphtTable.sortDesc = ctx.sortDesc
      // only fetch data when roles apply
      this.getAphtTableItems(this.aphtTable.currentPage)
    },
    filterDateTable(){
      this.filter.filterType = this.filter.value
      this.filter.filterValue = this.filter.filterSearch
      this.getAphtTableItems()
    },
    filterTable(event){
      event.preventDefault()
      this.filter.filterType = this.filter.value
      this.filter.filterValue = this.filter.filterSearch
      this.getAphtTableItems()
    },
    // get paginated table contents from server-side
    getAphtTableItems(page = 1) {
      if(isNaN(page)) {
        this.aphtTable.currentPage = 1
      }
      else {
        this.aphtTable.currentPage = page
      }
      // URL builder
      let getUrl = "/apht/getAllForCreator"
      
      let params = this.$helper.getBasePagedQuery(this.aphtTable.currentPage - 1, this.aphtTable.perPage)
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.aphtTable.sortBy != null) {
        params['sortBy'] = this.aphtTable.sortBy
        params['asc'] = !this.aphtTable.sortDesc
      }
      if(!this.$helper.isEmpty(this.filter.periodBy)){
        if(!this.$helper.isEmpty(this.filter.periodStart)){
          params['periodStart'] = this.filter.periodStart
          params['periodBy'] = this.filter.periodBy
        }
        if(!this.$helper.isEmpty(this.filter.periodEnd)){
          params['periodEnd'] = this.filter.periodEnd
          params['periodBy'] = this.filter.periodBy
        }
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.aphtTable.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            // sessionStorage.setItem("filterAPHTPage", this.aphtTable.currentPage)
            // sessionStorage.setItem("filterAPHTSize", this.aphtTable.perPage)
            sessionStorage.setItem("filterAPHTPeriodBy", this.filter.periodBy)
            sessionStorage.setItem("filterAPHTPeriodStart", this.filter.periodStart)
            sessionStorage.setItem("filterAPHTPeriodEnd", this.filter.periodEnd)
            sessionStorage.setItem("filterAPHTType", this.filter.filterType)
            sessionStorage.setItem("filterAPHTValue", this.filter.filterValue)
            sessionStorage.setItem("filterAPHTSortBy", this.aphtTable.sortBy)
            sessionStorage.setItem("filterAPHTAsc", this.aphtTable.sortDesc)
            this.aphtTable.items = response.data.data.data
            this.aphtTable.totalRows = response.data.data.totalElements
            this.aphtTable.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar APHT Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar APHT Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar APHT Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.aphtTable.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    downloadContracts(page = 1) {
      if(isNaN(page)) {
        this.aphtTable.currentPage = 1
      }
      else {
        this.aphtTable.currentPage = page
      }
      // URL builder
      let getUrl = "/excel/contractAphtByte"
      
      let params = this.$helper.getBasePagedQuery(this.aphtTable.currentPage - 1, this.aphtTable.perPage)
      if(!this.$helper.isEmpty(this.filter.periodBy)) {
        params['periodBy'] = this.filter.periodBy
        if(!this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)){
          params['periodStart'] = this.filter.periodStart
          params['periodEnd'] = this.filter.periodEnd
        }
      }
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.aphtTable.sortBy != null) {
        params['sortBy'] = this.aphtTable.sortBy
        params['asc'] = !this.aphtTable.sortDesc
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.isDownloading = true
        this.$axios.get(getUrl, {
          // necessary to avoid encoding returned bytes
          params: params, 
          responseType: 'blob',
          timeout: 300000
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= "Kontrak_APHT-" + Date.now() + ".xlsx"
            link.click();
          }
          else{
            this.$helper.toastError(this, "Download Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isDownloading = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },
  computed: {
  },
  mounted() {
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterAPHTPage"))){
    //   this.aphtTable.currentPage = sessionStorage.getItem("filterAPHTPage")
    // }
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterAPHTSize"))){
    //   this.aphtTable.perPage = sessionStorage.getItem("filterAPHTSize")
    // }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAPHTPeriodBy"))){
      this.filter.periodBy = sessionStorage.getItem("filterAPHTPeriodBy")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAPHTPeriodStart"))){
      this.filter.periodStart = sessionStorage.getItem("filterAPHTPeriodStart")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAPHTPeriodEnd"))){
      this.filter.periodEnd = sessionStorage.getItem("filterAPHTPeriodEnd")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAPHTType"))){
      this.filter.filterType = sessionStorage.getItem("filterAPHTType")
      this.filter.value = sessionStorage.getItem("filterAPHTType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAPHTValue"))){
      this.filter.filterValue = sessionStorage.getItem("filterAPHTValue")
      this.filter.filterSearch = sessionStorage.getItem("filterAPHTValue")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAPHTSortBy"))){
      this.aphtTable.sortBy = sessionStorage.getItem("filterAPHTSortBy")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterAPHTAsc"))){
      this.aphtTable.sortDesc = (sessionStorage.getItem("filterAPHTAsc") === 'true' ? true : false)
    }
    // get table contents on page load
    this.getAphtTableItems()
  },
  created() {
    if (this.$store.state.toast) {
      this.$helper.toastSuccess(this, this.$store.state.toastMsg)
      this.$store.commit('set', ['toast', false])
      this.$store.commit('set', ['toastMsg', ''])
    }
  }
}
</script>

<style>

</style>
